export default __webpack_public_path__ + "static/media/about.1c6c941a.svg";